var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3.78247","y":"-0.131836","width":"21","height":"2","rx":"1","transform":"rotate(45 3.78247 -0.131836)","fill":"#F9F9F9","key":0}),React.createElement("rect",{"x":"2.36829","y":"14.7175","width":"21","height":"2","rx":"1","transform":"rotate(-45 2.36829 14.7175)","fill":"#F9F9F9","key":1})]);
}

CloseInline.defaultProps = {"width":"21","height":"16","viewBox":"0 0 21 16","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
